import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export interface IAppendOTPVariables {
    id: number;
    reasonCode: number;
    reasonText?: string;
}

export function useAppendOTP(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, IAppendOTPVariables>({
        mutationKey: [QueryKeys.otp, 'append'],
        mutationFn: async ({ id, reasonCode, reasonText }: IAppendOTPVariables) => {
            return await OTPApi.appendOTP(id, reasonCode, reasonText);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });

            notifications.show({
                title: t('otp.notifications.appendSuccess.title'),
                message: t('otp.notifications.appendSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.appendError.title'),
                message: error?.message || t('otp.notifications.appendError.message'),
                color: 'red',
            });
        },
    });
}
